import { services } from '../services';
var action = "property";
/* eslint-disable no-console */
export const propertyService = {
    getAvailable,
    getList,
    getOne,
    getDropdowns,
    insert,
    update,
    remove,
    updatePrice,
    getHistory,
    merge,
    getSaleAndBookingByProperty,

};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function getDropdowns(projectId = 0) {
    return services.restApi(`${action}/dropdown/${projectId}`, 'GET');
}


function insert(object) {
    return services.restApi(`${action}`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/${id}`, 'DELETE');
}

function merge(id, object) {
    return services.restApi(`${action}/merge/${id}`, 'POST', object);
}

function getAvailable(projectId = 0, groupId = 0, book = 0, floor = 0) {

    let param = ``;

    if(projectId != 0) {
        param = `?project_id=${projectId}`;
    }

    if(groupId != 0) {
        param = param == '' ? `?group_id=${groupId}` : param + `&group_id=${groupId}`;
    }

    if(book != 0) {
        param = param == '' ? `?book=${book}` : param + `&book=${book}`;
    }

    if(floor != 0) {
        param = param == '' ? `?floor_id=${floor}` : param + `&floor_id=${floor}`;
    }

    // console.log(param);

    return services.restApi(`properties/available${param}`, 'GET');
}

function updatePrice(object) {
    return services.restApi(`properties/updateprice`, 'POST', object);
}

function getHistory(type, param="") {
    return services.restApi(`${action}/${type}-history/${param}`, 'GET');
}

function getSaleAndBookingByProperty(id) {
    return services.restApi(`cancelation/property/${id}`, 'GET');
}